import React, { Component } from 'react';
import './Dashboard.css';
import Logo from '../../assets/logo.png';
import Api from '../../service/AllApi';
import { CalendarOutline, WaterOutline, ResizeOutline, ColorPaletteOutline, ShieldOutline, ServerOutline } from 'react-ionicons'
import QrScan from 'react-qr-reader'


class Dashbaord extends Component {
    constructor(props) {
        super(props);
        this.state = { isMount: true, data: null, inputSerial:'' };

    }


    componentDidMount() {
        // if (navigator.mediaDevices.getUserMedia !== null) {
        //     navigator.mediaDevices.getUserMedia({
        //         video: true
        //     });
        //   }
    }
    handleScan = data => {
        if (data) {
            Api.create().checkSerial(data).then(response => {
                if (response.ok) {
                    //console.log("seeeee",response)
                    if (response.data) {
                        const data = response.data.map(line => {
                            line.ProductionDate = new Date(parseInt(line.ProductionDate.replace('/Date(', ''), 10));
                            line.ProductionDate = line.ProductionDate.getFullYear() + "-" + parseInt(line.ProductionDate.getMonth() + 1) + "-" + line.ProductionDate.getDate();
                            return line;
                        });
                        this.setState({ data: data[0], isMount: false })
                    }
                }
                else {
                    if (response.data) {
                        window.alert(response.data.ResponseStatus.Message)
                    }
                    else
                        window.alert(response.problem)
                }
            });
        }
    }
    handleError = err => {
        console.error(err)
    }


    render() {
        let s = this.state
        return (
            <div className="dashboard">
                <img src={Logo} style={{ width: 250, height: 180 }} />
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Scan Serial No</div>
                <div>
                    <QrScan
                        delay={100}
                        onError={this.handleError}
                        onScan={this.handleScan}
                        style={{ height: 200, width: 200 }}
                    //legacyMode={true}
                    />
                </div>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Enter serial no. if camera not activated</div>
                <div>
                    <input type="text" className="form-control" style={{marginBottom:30}} onChange={e=>{
                        this.setState({inputSerial:e.target.value })
                        }}/>
                    <button type="button" onClick={()=>this.handleScan(this.state.inputSerial)} className="btn">Submit</button>
                </div>
                <div className="menu-card">

                    <div className="card-item">
                        <CalendarOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Production date</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.ProductionDate : ''}</div>

                        {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems:'center' }}>
                            <CalendarOutline
                                color={'#00000'}
                                title={"Tesgin"}
                                height="30px"
                                width="30px"
                            />
                            <div style={{ textAlign: 'center' }}>Production date:</div>
                            
                            <div style={{ textAlign: 'center', backgroundColor: 'lightgray' }}>{s.data ? s.data.ProductionDate : ''}</div>
                        </div> */}
                    </div>
                    <div className="card-item">
                        <ResizeOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Batch No</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.BatchNo : ''}</div>
                    </div>
                    <div className="card-item">
                        <ResizeOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Product Size</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.FGSize : ''}</div>
                    </div>

                </div>
                <div className="menu-card">
                    <div className="card-item">
                        <WaterOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>pH</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.PH : ''}</div>

                    </div>
                    <div className="card-item">
                        <ResizeOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>ODOUR/SMELL</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.SMELL : ''}</div>
                    </div>
                    <div className="card-item">
                        <ResizeOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>TASTE</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.TASTE : ''}</div>
                    </div>
                    <div className="card-item">
                        <ColorPaletteOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Color</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.Color : ''}</div>
                    </div>
                    <div className="card-item">
                        <WaterOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Total Chlorine</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.TotalChlorine : ''}</div>
                    </div>
                    <div className="card-item">
                        <WaterOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Free Chlorine</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.FreeChlorine : ''}</div>
                    </div>
                    <div className="card-item">
                        <ShieldOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Total Hardness Grain</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.TotalHardnessGrain : ''}</div>
                    </div>
                    <div className="card-item">
                        <ServerOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Condition Bottle</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.ConditionBottle : ''}</div>
                    </div>
                </div>
                <div className="menu-card">

                    <div className="card-item">
                        <CalendarOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Ecoli</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.Ecoli : ''}</div>
                    </div>
                    <div className="card-item">
                        <ResizeOutline
                            color={'#00000'}
                            title={""}
                            height="40px"
                            width="40px"
                        />
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Coliform</div>
                        <div style={{ textAlign: 'center' }}>{s.data ? s.data.Coliform : ''}</div>
                    </div>

                </div>
            </div>
        );
    };

}

export default Dashbaord;